module.exports = __webpack_public_path__ + "img/story050@2x.3dbe01d0.png";